import React from 'react'
import { List } from 'semantic-ui-react'

const AppraisalInstructions = () =>
{
  return (
    <div style={{padding:'15px'}}>
      <List ordered>
        <List.Item>Put the items in list mode and select all (Ctrl+A)</List.Item>
        <List.Item>Copy (Ctrl+C) and Paste (Ctrl+V) the items into the box to the left</List.Item>
        <List.Item>Create an item exchange contract with the items to the corporation <em>Nothing Industries</em></List.Item>
        <List.Item>Put the quoted value as "I will receive"</List.Item>
        <List.Item>If you have any questions, please speak to us in #brave-empire-buyback</List.Item>
      </List>
    </div>
  );
}

export default AppraisalInstructions
